import { BfxBlotterAction } from "./BfxBlotterAction";

import { ContextMenuItem } from "../ContextMenuItem";
import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { ContextMenuState } from "../ContextMenuState";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class BfxBlotterContextMenuItem<T> extends ContextMenuItem<T> {
  public iconClass?: string;
  public clearSelection?: boolean;

  constructor(
    public actionId: BfxBlotterAction,
    _title: string,
    checkAvailable: ContextMenuItemStateCommand<T>,
    checkEnabled: ContextMenuItemStateCommand<T>,
    public checkAvailableCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.MenuItem,
    public checkEnabledCriteria: ContextMenuItemStateCommandCriteria = ContextMenuItemStateCommandCriteria.Item,
  ) {
    super(_title, checkAvailable, checkEnabled, checkAvailableCriteria, checkEnabledCriteria);
  }
}
